import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ecaadmin-dashboard',
  templateUrl: './ecaadmin-dashboard.component.html',
  styleUrls: ['./ecaadmin-dashboard.component.css']
})
export class EcaadminDashboardComponent implements OnInit {
  dashboard = false;
  sessions = false;
  students = false;
  tutors = false;
  subAdmins = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dashboard = true;
    this.sessions = false;
    this.students = false;
    this.tutors = false;
    this.subAdmins = false;
  }

  onDashboardClick() {
    this.dashboard = true;
    this.sessions = false;
    this.students = false;
    this.tutors = false;
    this.subAdmins = false;
  }

  onSessionsClick() {
    this.dashboard = false;
    this.sessions = true;
    this.students = false;
    this.tutors = false;
    this.subAdmins = false;
  }

  onStudentsClick() {
    this.dashboard = false;
    this.sessions = false;
    this.students = true;
    this.tutors = false;
    this.subAdmins = false;
  }

  onTutorsClick() {
    this.dashboard = false;
    this.sessions = false;
    this.students = false;
    this.tutors = true;
    this.subAdmins = false;
  }

  onSubAdminsClick() {
    this.dashboard = false;
    this.sessions = false;
    this.students = false;
    this.tutors = false;
    this.subAdmins = true;
  }

  onLogout() {
    localStorage.clear();
    this.router.navigate(['/ecademic/login']);
  }

}
